import {
  AtomicChecker,
  SectionChecker
} from "./chunk-EINJ42AI.mjs";
import {
  countChar,
  wordExists
} from "./chunk-D3GX5FQV.mjs";

// src/checker/check-desc-meta.ts
var CheckDescMeta = class extends SectionChecker {
  constructor(text, keyword, t) {
    super("Meta description score", text, keyword, t);
    this.checkLength();
    this.containsKeyword();
  }
  checkLength() {
    const textLength = countChar(this.text);
    const perfectMinimum = 100;
    const perfectMaximum = 160;
    const diff = perfectMaximum - textLength;
    const message = new AtomicChecker(
      "DESC_META_LENGTH",
      this.t("DESC_META_LENGTH", "short", diff, textLength, perfectMaximum)
    );
    if (textLength > 0) {
      if (textLength > perfectMaximum) {
        message.score = 10;
        message.text = this.t(
          "DESC_META_LENGTH",
          "long",
          diff,
          textLength,
          perfectMaximum
        );
        message.status = "good";
      } else if (textLength < perfectMinimum) {
        message.score = 10;
        message.text = this.t(
          "DESC_META_LENGTH",
          "short",
          diff,
          textLength,
          perfectMaximum
        );
        message.status = "good";
      } else {
        message.score = 85;
        message.text = this.t(
          "DESC_META_LENGTH",
          "perfect",
          diff,
          textLength,
          perfectMaximum
        );
        message.status = "perfect";
      }
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
  containsKeyword() {
    const message = new AtomicChecker(
      "DESC_META_USE_KEYWORD",
      this.t("DESC_META_USE_KEYWORD", "not_used", this.keyword)
    );
    if (wordExists(this.text, this.keyword)) {
      message.score = 15;
      message.text = this.t("DESC_META_USE_KEYWORD", "used", this.keyword);
      message.status = "perfect";
    }
    this.score += message.score;
    this.messages.push(message.getResult());
  }
};

export {
  CheckDescMeta
};
